<div class="row">
    <div class="container-fluid pl-0 pr-0">
        <div class="row">
            <div class="col-xl-12">
                <div class="card card-header-actions mx-auto">
                    <div class="card-header">
                        Leave Management
                        <div class="float-right ml-2">
                            <button data-toggle="modal" data-target="#holidayCalendar" class="btn btn-sm btn-primary mb-1"
                                (click)="loadApis('holiday')"> Holiday List
                            </button>&nbsp;&nbsp;
                            <button data-toggle="modal" data-target="#leaveBalance" class="btn btn-sm btn-primary mb-1"
                                (click)="loadApis('leavebal')"> Leave Balance
                            </button>&nbsp;&nbsp;
                            <button data-toggle="modal" data-target="#applyleave" class="btn btn-sm btn-primary"
                                (click)="loadApis('applyLeave')"> Apply Leave
                            </button>&nbsp;&nbsp;
                            <button data-toggle="modal" data-target="#applycompff" class="btn btn-sm btn-primary"
                                (click)="loadApis('compoff')"> Apply compff
                            </button>&nbsp;&nbsp;
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-xl-3 mb-3">
                                <label>Leave Type</label>
                                <select class="form-control form-control-sm" [(ngModel)]="selectedLeaveTypeFilter"
                                    (change)="filterLeaveType($event)" [ngModelOptions]="{standalone: true }">
                                    <option value="1">Applied Leaves</option>
                                    <option value="2">CompOff Requests</option>
                                </select>
                            </div>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-striped table-bordered table-sm" style="width: 100%" datatable
                                [dtOptions]="dtOptions" *ngIf="dtReneder">
                                <thead>
                                    <tr>
                                        <th class="text-center">Sl NO</th>
                                        <th>Name</th>
                                        <th *ngIf="selectedLeaveTypeFilter == '1'">From Date/Start Time</th>
                                        <th *ngIf="selectedLeaveTypeFilter == '1'">To Date/End Time</th>
                                        <th *ngIf="selectedLeaveTypeFilter == '2'">Comp Off Date</th>
                                        <th *ngIf="selectedLeaveTypeFilter == '2'">Comp Off Expiry Date</th>
                                        <th style="white-space: nowrap;">Applied Date</th>
                                        <th *ngIf="selectedLeaveTypeFilter == '1'">Leave type</th>
                                        <th *ngIf="selectedLeaveTypeFilter == '2'">Holiday Name</th>
                                        <th *ngIf="selectedLeaveTypeFilter == '1'">Reason</th>
                                        <th>No Of Days</th>
                                        <th>Status</th>
                                        <th *ngIf="selectedLeaveTypeFilter == '1'">Related Docs</th>
                                        <th>Approved/Rejected By Name</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let g of leaveLst;let i=index">
                                        <td class="text-center">{{i+1}}</td>
                                        <td style="white-space: nowrap;">{{g?.name || g?.user_name}}</td>
                                        <td *ngIf="selectedLeaveTypeFilter == '1'">{{g?.from_date | date:'dd-MM-yyy'}} {{g?.end_time ?(g?.start_time | date:'HH:mm'):''}}</td>
                                        <td *ngIf="selectedLeaveTypeFilter == '1'">{{g?.to_date | date:'dd-MM-yyy'}} {{g?.end_time ?(g?.end_time | date:'HH:mm'):''}}</td>
                                        <td *ngIf="selectedLeaveTypeFilter == '2'">{{g?.comp_off_date | date:'dd-MM-yyy HH:mm'}}</td>
                                        <td *ngIf="selectedLeaveTypeFilter == '2'">{{g?.comp_off_expiry_date |
                                            date:'dd-MM-yyy HH:mm'}}</td>
                                        <td>{{g?.applied_date | date:'dd-MM-yyy'}}</td>
                                        <td *ngIf="selectedLeaveTypeFilter == '1'" style="white-space: nowrap;">{{g?.leave_type}}</td>
                                        <td *ngIf="selectedLeaveTypeFilter == '2'">{{g?.holiday_name}}</td>
                                        <td class="wrap-text" *ngIf="selectedLeaveTypeFilter == '1'" >{{g?.reasons}}</td>
                                        <td>{{g?.no_of_days}}</td>
                                        <td
                                            [ngStyle]="{'color':g?.status_type === 'CANCELLED' || g?.status_type === 'REJECTED' ? 'red' : g?.status_type === 'APPROVED' ? 'green' : 'orange'}">
                                            {{g?.status_type}}</td>
                                        <td *ngIf="selectedLeaveTypeFilter == '1'" (click)="g?.document && viewImage(g.document)"
                                            [style.cursor]="g?.document ? 'pointer' : 'default'">
                                            <span *ngIf="g?.document" style="color: blue; text-decoration: underline;"> View Document</span>
                                            <span *ngIf="!g?.document">No Document</span>
                                        </td>
                                        <td>{{g?.approved_by_name}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal" id="holidayCalendar" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5>Holiday Calendar</h5>
                <button type="button" class="close btn btn-light float-end" data-dismiss="modal" (click)="loadData()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div>
                    <div class="table-responsive">
                        <table class="table table-striped table-bordered table-sm" style="width: 100%" datatable
                            [dtOptions]="dtOptions" *ngIf="dtReneder">
                            <thead>
                                <tr>
                                    <th class="text-center">Sl NO</th>
                                    <th>Holiday Name</th>
                                    <th>Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let g of hldyLst;let i=index">
                                    <td class="text-center">{{i+1}}</td>
                                    <td>{{g?.name}}</td>
                                    <td>{{g?.date | date:'dd-MM-yyy'}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal" id="leaveBalance" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5>Leave Balance</h5>
                <button type="button" class="close btn btn-light float-end" data-dismiss="modal" (click)="loadData()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div>
                    <div class="table-responsive">
                        <table class="table table-striped table-bordered table-sm" style="width: 100%" datatable
                            [dtOptions]="dtOptions" *ngIf="dtReneder">
                            <thead>
                                <tr>
                                    <th class="text-center">Sl NO</th>
                                    <th>Name</th>
                                    <th>Designation</th>
                                    <th>Leaves Taken</th>
                                    <th>Opening Balance</th>
                                    <th>Remaining Balance </th>
                                    <th>Comp-off Taken</th>
                                    <th>Comp-off</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let g of leaveBalanceLSt;let i=index">
                                    <td class="text-center">{{i+1}}</td>
                                    <td>{{g?.name}}</td>
                                    <td>{{g?.designation}}</td>
                                    <td>{{g?.leave_taken}}</td>
                                    <td>{{g?.opening_balance}}</td>
                                    <td>{{g?.remaining_balance}}</td>
                                    <td>{{g?.comp_off_taken}}</td>
                                    <td>{{g?.comp_off}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal" id="applyleave" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5>Apply Leave</h5>
                <button type="button" class="close btn btn-light float-end" data-dismiss="modal" (click)="loadData()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form [formGroup]="leaveApplyForm">
                    <div class="row">
                        <div class="col-xl-3">
                            <label class="control-label">Leave Type<span class="text-danger">*</span></label>
                            <select class="form-control form-control-sm" formControlName="selectedLeaveType" (change)="validateLeaveType($event.target.value)">
                                <option value="">Select</option>
                                <option [value]="g.id" *ngFor="let g of leaveTypes">{{g.name}}</option>
                            </select>
                            <div>
                                <small class="text-danger"
                                    *ngIf="leaveApplyForm.get('selectedLeaveType').invalid && leaveApplyForm.get('selectedLeaveType').touched">Leave
                                    Type is required</small>
                            </div>
                        </div>
                        <div class='col-xl-3'>
                            <div class="form-group">
                                <div class='date' id='datetimepicker6'>
                                    <label class="control-label">Applied Date<span class="text-danger">*</span>
                                    </label>
                                    <div>
                                        <input id="appliedDate" name="appliedDate" type="text" autocomplete="off"
                                            onpaste="return false" placeholder="DD-MM-YYYY" bsDatepicker
                                            #dp="bsDatepicker" (focus)="dp.show()" formControlName="appliedDate"
                                            onkeypress='return event.charCode == 8'
                                            [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY', showWeekNumbers: false,minDate:minDate, maxDate:maxDate }"
                                            class="form-control form-control-sm">
                                    </div>
                                    <div>
                                        <small class="text-danger"
                                            *ngIf="leaveApplyForm.get('appliedDate').invalid && leaveApplyForm.get('appliedDate').touched">Applied
                                            Date is required</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class='col-xl-3' *ngIf="enableFromDate">
                            <div class="form-group">
                                <div class='date' id='datetimepicker6'>
                                    <label class="control-label">From Date<span class="text-danger">*</span>
                                    </label>
                                    <div>
                                        <input id="fromDate" name="fromDate" type="text" autocomplete="off"
                                            onpaste="return false" placeholder="DD-MM-YYYY" bsDatepicker
                                            #dp="bsDatepicker" (focus)="dp.show()" formControlName="fromDate"  (bsValueChange)="updateDateLimits('fromDate', $event)"
                                            onkeypress='return event.charCode == 8' [minDate]="fromMinDate" [maxDate]="fromMaxDate"
                                            [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY', showWeekNumbers: false}"
                                            class="form-control form-control-sm">
                                    </div>
                                    <div>
                                        <small class="text-danger"
                                            *ngIf="leaveApplyForm.get('fromDate').invalid && leaveApplyForm.get('fromDate').touched">From
                                            Date is required</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class='col-xl-3' *ngIf="enableToDate">
                            <div class="form-group">
                                <div class='date' id='datetimepicker6'>
                                    <label class="control-label">To Date<span class="text-danger">*</span>
                                    </label>
                                    <div>
                                        <input id="toDate" name="toDate" type="text" autocomplete="off"
                                            onpaste="return false" placeholder="DD-MM-YYYY" bsDatepicker
                                            #dp="bsDatepicker" (focus)="dp.show()" formControlName="toDate" (bsValueChange)="updateDateLimits('toDate', $event)"
                                            onkeypress='return event.charCode == 8'  [minDate]="toMinDate" [maxDate]="toMaxDate"
                                            [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY', showWeekNumbers: false  }"
                                            class="form-control form-control-sm">
                                    </div>
                                    <div>
                                        <small class="text-danger"
                                            *ngIf="leaveApplyForm.get('toDate').invalid && leaveApplyForm.get('toDate').touched">To
                                            Date is required</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3" *ngIf="enableFromDayType">
                            <label class="control-label">Select From Day Type<span class="text-danger">*</span></label>
                            <div>
                                <label *ngIf="enableFromHalfdayType">
                                    <input type="radio" name="fromDayType"formControlName="fromDayType" value="1" >
                                    Half Day
                                </label>
                                <label>
                                    <input type="radio" name="fromDayType"  class="ml-1"  formControlName="fromDayType" value="2">
                                    Full Day
                                </label>
                            </div>
                            <div>
                                <small class="text-danger"
                                    *ngIf="leaveApplyForm.get('fromDayType').invalid && leaveApplyForm.get('fromDayType').touched">From
                                    Day Type is required</small>
                            </div>
                        </div>
                        <div class="col-xl-3" *ngIf="enableToDayType" >
                            <label class="control-label">Select To Day Type<span class="text-danger">*</span></label>
                            <div>
                                <input type="radio" name="toDayType" formControlName="toDayType" value="1"> Half Day
                                <input type="radio" name="toDayType" formControlName="toDayType" value="2"> Full Day
                            </div>
                            <div>
                                <small class="text-danger"
                                    *ngIf="leaveApplyForm.get('toDayType').invalid && leaveApplyForm.get('toDayType').touched">To
                                    Day Type is required</small>
                            </div>
                        </div>
                         <div class="col-xl-3" *ngIf="enableStartTime">
                            <label class="form-label">Start Time<span class="text-danger">*</span></label>
                            <div class='date' id='datetimepicker6'>
                                <div>
                                    <input type="time" class="form-control form-control-sm" formControlName="applystartTime" (change)="onStartTimeChange($event)">
                                </div>
                                <div>
                                    <small class="text-danger"
                                        *ngIf="leaveApplyForm.get('applystartTime').invalid && leaveApplyForm.get('applystartTime').touched">Start Time
                                        is required</small>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3" *ngIf="enableendTime">
                            <label class="form-label">End Time<span class="text-danger">*</span></label>
                            <div class='date' id='datetimepicker6'>
                                <div>
                                    <input type="time" class="form-control form-control-sm" formControlName="applyendTime" readonly>
                                </div>
                                <div>
                                    <small class="text-danger"
                                        *ngIf="leaveApplyForm.get('applyendTime').invalid && leaveApplyForm.get('applyendTime').touched">End Time
                                        is required</small>
                                </div>
                            </div>
                        </div>
                         <div class="col-xl-3" *ngIf="enableHalfFullType">
                            <label class="control-label">Select From Day Type<span class="text-danger">*</span></label>
                            <div>
                                <input type="radio" name="halfFullDayType" formControlName="halfFullDayType" value="1"> First Half <br>
                                <input type="radio" name="halfFullDayType" formControlName="halfFullDayType" value="2"> Second Half
                            </div>
                            <div>
                                <small class="text-danger"
                                    *ngIf="leaveApplyForm.get('halfFullDayType').invalid && leaveApplyForm.get('halfFullDayType').touched">From
                                    Day Type is required</small>
                            </div>
                        </div>
                       
                        <div class="col-xl-6">
                            <label class="form-label">Reason<span class="text-danger">*</span></label>
                            <textarea class="form-control form-control-sm" rows="3" maxlength="1000"
                                formControlName="reasons"> </textarea>
                            <div>
                                <small class="text-danger"
                                    *ngIf="leaveApplyForm.get('reasons').invalid && leaveApplyForm.get('reasons').touched">Reason
                                    is required</small>
                            </div>
                        </div>
                        <div class="col-xl-3 col-md-6">
                            <label class="control-label">File Upload</label>
                            <input type="file" (change)="onFileChange($event)"  [(ngModel)]="uploadFile" [ngModelOptions]="{standalone :true}">
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <div class="row">
                    <div class="col-xl-12">
                        <div class="d-flex justify-content-end align-items-center">
                            <button class="btn btn-sm btn-primary"
                                (click)="saveAppliedLeave()">Save</button>&nbsp;&nbsp;
                            <button class="btn btn-sm btn-danger" data-dismiss="modal" (click)="loadData()">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal" id="applycompff" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5>Apply Compff</h5>
                <button type="button" class="close btn btn-light float-end" data-dismiss="modal" (click)="loadData()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form [formGroup]="compOffApplyForm">
                    <div class="row">
                        <div class="col-xl-3">
                            <label class="form-label">Applied Date<span class="text-danger">*</span></label>
                            <div class='date' id='datetimepicker6'>
                                <div>
                                    <input id="compOffappliedDate" name="compOffappliedDate" type="text"
                                        autocomplete="off" onpaste="return false" placeholder="DD-MM-YYYY" bsDatepicker
                                        #dp="bsDatepicker" formControlName="compOffappliedDate"
                                        onkeypress='return event.charCode == 8' (bsValueChange)="comOffOnly($event)"
                                        [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY', showWeekNumbers: false , minDate: minDate, maxDate: maxDate }"
                                        class="form-control form-control-sm">
                                </div>
                                <div>
                                    <small class="text-danger"
                                        *ngIf="compOffApplyForm.get('compOffappliedDate').invalid && compOffApplyForm.get('compOffappliedDate').touched">Applied
                                        is required</small>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3">
                            <label class="form-label">Compff Date<span class="text-danger">*</span></label>
                            <div class='date' id='datetimepicker6'>
                                <div>
                                    <input id="compOffDate" name="compOffDate" type="text" autocomplete="off"
                                        onpaste="return false" placeholder="DD-MM-YYYY" bsDatepicker #dp="bsDatepicker"
                                        formControlName="compOffDate" onkeypress='return event.charCode == 8' [maxDate]="compOffApplyForm.value.compOffappliedDate" [minDate]="compOffDateonly"
                                        [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY', showWeekNumbers: false }"
                                        class="form-control form-control-sm">
                                </div>
                                <div>
                                    <small class="text-danger"
                                        *ngIf="compOffApplyForm.get('compOffDate').invalid && compOffApplyForm.get('compOffDate').touched">Compff
                                        Date is required</small>
                                </div>

                            </div>
                        </div>
                        <div class="col-xl-3">
                            <label class="form-label">Start Time<span class="text-danger">*</span></label>
                            <div class='date' id='datetimepicker6'>
                                <div>
                                    <input type="time" class="form-control form-control-sm" formControlName="startTime">
                                </div>
                                <div>
                                    <small class="text-danger"
                                        *ngIf="compOffApplyForm.get('startTime').invalid && compOffApplyForm.get('startTime').touched">Start Time
                                        is required</small>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3">
                            <label class="form-label">End Time<span class="text-danger">*</span></label>
                            <div class='date' id='datetimepicker6'>
                                <div>
                                    <input type="time" class="form-control form-control-sm" formControlName="endTime">
                                </div>
                                <div>
                                    <small class="text-danger"
                                        *ngIf="compOffApplyForm.get('endTime').invalid && compOffApplyForm.get('endTime').touched">End Time
                                        is required</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <div class="row">
                    <div class="col-xl-12">
                        <div class="d-flex justify-content-end align-items-center">
                            <button class="btn btn-sm btn-primary" (click)="saveCompOff()">Save</button>&nbsp;&nbsp;
                            <button class="btn btn-sm btn-danger" data-dismiss="modal" (click)="loadData()">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>